import { configureStore } from '@reduxjs/toolkit'
import rootReducer from 'src/reducers'
import { customerApi } from 'src/slices/hooks/customer'
import { globalApi } from 'src/slices/hooks/global'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware(),
    globalApi.middleware,
    customerApi.middleware,
  ],
  // devTools: process.env.REACT_APP_ENV === 'development',
  devTools: false,
})

export default store
